import React, { Dispatch, RefObject } from 'react';
import { Mention, MentionsInput } from 'react-mentions';
import { IPartyForUser } from '../../PartyClientResponse';
import { useAppState } from '../../state/AppState';

const NOT_WHITE_SPACE = String.fromCharCode(8287);

const MessageInput = ({
  inputRef,
  inputValue,
  setInputValue,
}: {
  inputRef: RefObject<HTMLTextAreaElement>;
  inputValue: string;
  setInputValue: Dispatch<React.SetStateAction<string>>;
}) => {
  const { party } = useAppState();

  const inputStyle = {
    color: 'white',
    height: '100%',
    borderRadius: 20,
    border: 'none',
  };

  return (
    <MentionsInput
      inputRef={inputRef}
      className='chat-input'
      style={inputStyle}
      value={inputValue}
      autoFocus
      singleLine
      allowSuggestionsAboveCursor
      onChange={(e: any, newValue: string) => setInputValue(newValue)}>
      <Mention
        trigger='@'
        data={Object.values(party?.stage?.participants || {}).map((p) => ({
          id: p.uid,
          display: p.displayName?.replaceAll(' ', NOT_WHITE_SPACE)?.replaceAll(' ', '') || '',
        }))}
        displayTransform={(id, display) => `@${display} `}
        markup='@[__display__](__id__) '
      />
    </MentionsInput>
  );
};

export default MessageInput;
